import { MalwareIcon } from '@frontend/legacy-components/src/components/mediaAndIcons/icons/iconSet';

export const HasVirusThumbnail = () => {
  return (
    <MalwareIcon
      h="auto"
      w="fit-content"
      p="15%"
      maxHeight="100%"
      maxWidth="100%"
      objectFit="contain"
      verticalAlign="middle"
    />
  );
};
